const stories = {
  'zh-CN': {
    eyebrow: 'OUR STORY',
    title: '品牌故事',
    lead: '每一间专业厨房，表象或许大同小异，真正支撑它的，是品质与信赖。',
    origin: [
      'Vervesteel 植根于深厚的商用厨房工程积淀。依托深圳时代厨房设备有限公司多年行业实践，我们将对材料、设计、智造与工程的理解，融入每一个项目。',
      '我们始终相信，厨房设备不只是一件产品，更承载着对品质、标准与交付的承诺。',
      '客户需要的远不止设备，而是稳定的品质、专业的工程、可靠的交付，以及值得长期信赖的伙伴。这，便是 Vervesteel 的初心。'
    ],
    focus: '我们专注于商用厨房设备与整体解决方案，以专业制造与工程经验，为全球客户打造经得起高强度运营与时间检验的厨房系统。',
    markIntro: '标识中的 VS，既是 Vervesteel 的品牌缩写，亦代表我们的核心信条：',
    mark: 'Value through Strength',
    markChinese: '实力铸就价值',
    promise: '我们相信，真正长久的价值，从来不止于一次交付，而源于一次次可靠履约，以及日积月累的信任。',
    closing: '单次交付只是起点，长久信赖方为目标。',
    signature: 'Built on Experience. Driven by Strength.'
  },
  'zh-TW': {
    eyebrow: 'OUR STORY',
    title: '品牌故事',
    lead: '每一間專業廚房，表象或許大同小異，真正支撐它的，是品質與信賴。',
    origin: [
      'Vervesteel 植根於深厚的商用廚房工程積澱。依託深圳時代廚房設備有限公司多年行業實踐，我們將對材料、設計、智造與工程的理解，融入每一個專案。',
      '我們始終相信，廚房設備不只是一件產品，更承載著對品質、標準與交付的承諾。',
      '客戶需要的遠不止設備，而是穩定的品質、專業的工程、可靠的交付，以及值得長期信賴的夥伴。這，便是 Vervesteel 的初心。'
    ],
    focus: '我們專注於商用廚房設備與整體解決方案，以專業製造與工程經驗，為全球客戶打造經得起高強度營運與時間檢驗的廚房系統。',
    markIntro: '標識中的 VS，既是 Vervesteel 的品牌縮寫，亦代表我們的核心信條：',
    mark: 'Value through Strength',
    markChinese: '實力鑄就價值',
    promise: '我們相信，真正長久的價值，從來不止於一次交付，而源於一次次可靠履約，以及日積月累的信任。',
    closing: '單次交付只是起點，長久信賴方為目標。',
    signature: 'Built on Experience. Driven by Strength.'
  },
  en: {
    eyebrow: 'OUR STORY',
    title: 'Our Story',
    lead: 'Professional kitchens may look much alike. What truly supports them is quality—and trust.',
    origin: [
      'Vervesteel is grounded in deep experience delivering commercial kitchen projects. Building on the many years of practice of Shenzhen Times Kitchen Equipment Co., Ltd., we bring our understanding of materials, design, smart manufacturing and engineering to every project.',
      'We believe kitchen equipment is more than a product. It carries a commitment to quality, standards and delivery.',
      'Customers need more than equipment: consistent quality, professional engineering, dependable delivery and a partner worthy of long-term trust. This is the founding purpose of Vervesteel.'
    ],
    focus: 'We specialize in commercial kitchen equipment and integrated solutions. Combining professional manufacturing with engineering experience, we build kitchen systems for clients worldwide—made to stand up to demanding operations and the test of time.',
    markIntro: 'The VS in our mark represents both the Vervesteel name and our guiding belief:',
    mark: 'Value through Strength',
    markChinese: 'Strength creates value',
    promise: 'We believe lasting value goes beyond a single delivery. It is built through dependable commitments, fulfilled time and again, and trust earned over the years.',
    closing: 'Every delivery is a beginning. Long-term trust is the goal.',
    signature: 'Built on Experience. Driven by Strength.'
  },
  es: {
    eyebrow: 'NUESTRA HISTORIA',
    title: 'Nuestra historia',
    lead: 'Las cocinas profesionales pueden parecerse. Lo que realmente las sostiene es la calidad y la confianza.',
    origin: [
      'Vervesteel se apoya en una amplia experiencia en proyectos de cocinas comerciales. Sobre la trayectoria de Shenzhen Times Kitchen Equipment Co., Ltd., incorporamos a cada proyecto nuestro conocimiento de materiales, diseño, fabricación inteligente e ingeniería.',
      'Creemos que el equipamiento de cocina es mucho más que un producto: representa un compromiso con la calidad, los estándares y la entrega.',
      'Nuestros clientes necesitan más que equipos: calidad constante, ingeniería profesional, entregas fiables y un socio digno de su confianza a largo plazo. Ese es el propósito con el que nació Vervesteel.'
    ],
    focus: 'Nos especializamos en equipos para cocinas comerciales y soluciones integrales. Gracias a nuestra fabricación profesional y experiencia en ingeniería, creamos para clientes de todo el mundo sistemas de cocina preparados para operaciones exigentes y para perdurar en el tiempo.',
    markIntro: 'Las letras VS de nuestro logotipo representan Vervesteel y nuestra convicción fundamental:',
    mark: 'Value through Strength',
    markChinese: 'La fortaleza crea valor',
    promise: 'Creemos que el valor duradero va más allá de una entrega. Nace de cumplir con fiabilidad, una y otra vez, y de la confianza construida con el tiempo.',
    closing: 'Cada entrega es el comienzo; la meta es una confianza duradera.',
    signature: 'Built on Experience. Driven by Strength.'
  }
}

export default stories
